/**
 * @generated SignedSource<<de29d2627eb6645af4f5179dd7e36f14>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type PianofunclubEnrolmentModelStatusChoices = "ARCHIVED" | "ENROLED" | "OFFERED" | "WAITING_LIST" | "%future added value";
export type OfferLessonBlockToNewPupilInput = {
  archiveExistingOffer?: boolean | null | undefined;
  clientMutationId?: string | null | undefined;
  enrolmentId: string;
  lessonBlockId: string;
  messageString: string;
  messageSubject: string;
};
export type OfferLessonBlockToNewPupilMutation$variables = {
  input: OfferLessonBlockToNewPupilInput;
};
export type OfferLessonBlockToNewPupilMutation$data = {
  readonly offerLessonBlockToNewPupil: {
    readonly archivedEnrolmentOffers: ReadonlyArray<{
      readonly archived: boolean;
      readonly archivedTimestamp: string | null | undefined;
      readonly enrolment: {
        readonly id: string;
        readonly status: PianofunclubEnrolmentModelStatusChoices;
      };
      readonly id: string;
    } | null | undefined> | null | undefined;
    readonly enrolment: {
      readonly id: string;
      readonly lastOfferedTimestamp: string | null | undefined;
      readonly offers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly enrolment: {
              readonly id: string;
              readonly pupilFirstName: string | null | undefined;
              readonly pupilLastName: string | null | undefined;
            };
            readonly id: string;
          } | null | undefined;
        } | null | undefined>;
      };
      readonly status: PianofunclubEnrolmentModelStatusChoices;
    } | null | undefined;
    readonly errors: any | null | undefined;
    readonly lessonBlock: {
      readonly enrolmentOffers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly enrolment: {
              readonly id: string;
              readonly pupilFirstName: string | null | undefined;
              readonly pupilLastName: string | null | undefined;
            };
            readonly id: string;
          } | null | undefined;
        } | null | undefined>;
      };
      readonly id: string;
    } | null | undefined;
    readonly success: boolean | null | undefined;
  } | null | undefined;
};
export type OfferLessonBlockToNewPupilMutation = {
  response: OfferLessonBlockToNewPupilMutation$data;
  variables: OfferLessonBlockToNewPupilMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "kind": "Literal",
    "name": "archived",
    "value": false
  },
  {
    "kind": "Literal",
    "name": "offerAccepted",
    "value": false
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "EnrolmentOfferNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "EnrolmentOfferNode",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrolmentNode",
            "kind": "LinkedField",
            "name": "enrolment",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pupilFirstName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "pupilLastName",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "OfferLessonBlockToNewPupilPayload",
    "kind": "LinkedField",
    "name": "offerLessonBlockToNewPupil",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "LessonBlockNode",
        "kind": "LinkedField",
        "name": "lessonBlock",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "EnrolmentOfferNodeConnection",
            "kind": "LinkedField",
            "name": "enrolmentOffers",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": "enrolmentOffers(archived:false,offerAccepted:false)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EnrolmentNode",
        "kind": "LinkedField",
        "name": "enrolment",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastOfferedTimestamp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v2/*: any*/),
            "concreteType": "EnrolmentOfferNodeConnection",
            "kind": "LinkedField",
            "name": "offers",
            "plural": false,
            "selections": (v3/*: any*/),
            "storageKey": "offers(archived:false,offerAccepted:false)"
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "EnrolmentOfferNode",
        "kind": "LinkedField",
        "name": "archivedEnrolmentOffers",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archived",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "archivedTimestamp",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "EnrolmentNode",
            "kind": "LinkedField",
            "name": "enrolment",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "OfferLessonBlockToNewPupilMutation",
    "selections": (v5/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "OfferLessonBlockToNewPupilMutation",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "3e90b926a21bb8bfef728b00b87a7d69",
    "id": null,
    "metadata": {},
    "name": "OfferLessonBlockToNewPupilMutation",
    "operationKind": "mutation",
    "text": "mutation OfferLessonBlockToNewPupilMutation(\n  $input: OfferLessonBlockToNewPupilInput!\n) {\n  offerLessonBlockToNewPupil(input: $input) {\n    success\n    errors\n    lessonBlock {\n      id\n      enrolmentOffers(archived: false, offerAccepted: false) {\n        edges {\n          node {\n            id\n            enrolment {\n              id\n              pupilFirstName\n              pupilLastName\n            }\n          }\n        }\n      }\n    }\n    enrolment {\n      id\n      status\n      lastOfferedTimestamp\n      offers(archived: false, offerAccepted: false) {\n        edges {\n          node {\n            id\n            enrolment {\n              id\n              pupilFirstName\n              pupilLastName\n            }\n          }\n        }\n      }\n    }\n    archivedEnrolmentOffers {\n      id\n      archived\n      archivedTimestamp\n      enrolment {\n        id\n        status\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e94f349727c94e9f9de9df1d888a661d";

export default node;
